
import MyAbodeOverviewStoreName from '@/store/my-abode-overview/name';
import routes from '@/constants/routes';
import { MyAbodeOverviewTrackEvent } from '@/constants/AnalyticEvents';
import MyAbodeOverviewMainSectionContent from './content';

export default {
  name: 'MyAbodeOverviewMainSection',
  components: {
    MyAbodeOverviewMainSectionContent,
  },
  data() {
    return {
      marketDataList: null,
      soldDataList: null,
      comparableList: null,
      routes,
      MyAbodeOverviewTrackEvent,
    };
  },
  computed: {
    marketDataContent() {
      return this.$store.state[MyAbodeOverviewStoreName].marketDataContent;
    },
    soldDataContent() {
      return this.$store.state[MyAbodeOverviewStoreName].soldDataContent;
    },
    comparableContent() {
      return this.$store.state[MyAbodeOverviewStoreName].comparableContent;
    },
  },
  mounted() {
    this.marketDataList = this.createListArray(this.marketDataContent);
    this.soldDataList = this.createListArray(this.soldDataContent);
    this.comparableList = this.createListArray(this.comparableContent);
  },
  methods: {
    createListArray(content) {
      const keyText = 'bullet';

      return Object.entries(content)
        .filter(([key]) => key.includes(keyText))
        .map(([, value]) => value);
    },
  },
};
